import React, { useContext, useState } from "react";
import styled from '@emotion/styled';
import { color, formStyles, breakpoints } from '../../../utils/style';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { registerUrl } from '../Config.js'
import IcomoonIcon from '../../shared/IcomoonIcon';
import StoreContext from '../../shared/Context/StoreContext';
import PopupWindow from '../../shared/PopupWindow';
import LinePopupContent from '../../Content/Register/LinePopupContent';
import GetWindowWidth from '../../shared/GetWindowWidth';

const Wrapper = styled('div')`
  ${formStyles}
  position: relative;
  padding: 0 0 20px;
  margin-top: -10px;
  text-align: left;
  .loading {
    position:relative;
  }
  .loading::before {
    content: "";
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background: ${color.black};
    opacity:0.7;
    z-index: 1;
  }
  .two-fields {
    .fieldWrap {
      width: 48%;
      display: inline-block;
      vertical-align: top;
      &:first-of-type {
        margin-right: 4%;
      }
    }
  }
  .red-button {
    float: right;
  }
  .button {
    svg {
      margin-left: 5px;
    }
    &:disabled {
      svg {
        opacity: 0.5;
      }
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .two-fields {
      .fieldWrap {
        width: 100%;
        padding-bottom: 10px;
        &:first-of-type {
          margin-right: 0;
        }
      }
    }
  }
`;

const MsgWrap = styled('div')`
  span {
    background-color:${color.yellow};
    color: ${color.black};
    padding:5px 10px;
    text-align:center;
    
    @media (max-width: ${breakpoints.sm}) {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 200;
      padding: 20px;
      border-radius: 0;
    }

    &.errorMsg,
    &.successMsg {
      display: block;
    }
  }
`;

const GamesWrap = styled('div')`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  h4 {
    flex-basis: 100%;
  }
  
`;

const GameNode = styled('div')`
  flex-basis: 49%;
  position: relative;
  height: 56px;
  margin-bottom: 7px;
  .game-tile-img {
    position: absolute;
    left: 10px;
    top: 5px;
  }
  .checkbox-container {
    position: relative;
    display: block;
    cursor: pointer;
    padding: 15px 50px 15px 20px;
    background: ${color.transparentWhite1};
    border-radius: 25px;
    color: ${color.white};
    &:hover {
      background: ${color.transparentWhite2};
    }
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
      &:checked ~ .checkmark {
        &::after {
          display: block;
        }
      }
    }
    input:checked ~ .checkmark {
      .mark {
        display: block;
      }
    }
  }
  .checkmark {
    position: absolute;
    right: 10px;
    top: 6px;
    width: 36px;
    height: 36px;
    border: 1px solid ${color.white};
    border-radius: 20px;
    .mark {
      display: none;
      position: absolute;
      top: 7px;
      left: 13px;
      width: 7px;
      height: 15px;
      border: solid white;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  .game-tile-img + .checkbox-container {
    padding-left: 60px;
  }
  
  @media (max-width: ${breakpoints.sm}) {
    flex-basis: 100%;
    font-size: 13px;
    line-height: 18px;
  }
  
`;

const gamesStatic = [
  {
    value: "Bacc1688",
    label: "Bacc1688",
    thumb: false,
    code: "Bacc1688",
  },
  {
    value: "Sbobet",
    label: "Sbobet",
    thumb: false,
    code: "Sbobet"
  },
  {
    value: "Goldenslot",
    label: "Goldenslot",
    thumb: false,
    code: "Goldenslot"
  },
  {
    value: "Royal1688",
    label: "Royal1688",
    thumb: false,
    code: "Royal1688"
  },
  {
    value: "Goldclub",
    label: "Goldclub",
    thumb: false,
    code: "Goldclub"
  },
  {
    value: "Ruby888",
    label: "Ruby888",
    thumb: false,
    code: "Ruby888"
  },
  {
    value: "Genting Princess Casino",
    label: "Genting Princess Casino",
    thumb: false,
    code: "Genting Princess Casino"
  },
  {
    value: "Reddit88",
    label: "Reddit88",
    thumb: false,
    code: "Reddit88"
  },
  {
    value: "Genting Crown Poipet",
    label: "Genting Crown Poipet",
    thumb: false,
    code: "Genting Crown Poipet"
  },
  {
    value: "SCR888",
    label: "SCR888",
    thumb: false,
    code: "SCR888"
  },
  {
    value: "iBet789",
    label: "iBet789",
    thumb: false,
    code: "iBet789"
  },
  {
    value: "Maxbet",
    label: "Maxbet",
    thumb: false,
    code: "Maxbet"
  }
];

const initialValues = {
  games: "",
  username: "",
  email: "",
  phone: "",
  line: "",
  password: "",
  register_type: { real_money: false, free_speen: false }
};

// Checkbox input
const Checkbox = ({
                    field: { name, value, onChange, onBlur },
                    form: { errors, touched, setFieldValue },
                    id,
                    label,
                    ...props
                  }) => {
  return (
    <div className="minimal-custom-checkbox">
      <input
        name={name}
        id={id}
        type="checkbox"
        value={value}
        checked={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

const FormBody = ({games}) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  
  const onSubmit = (values, { resetForm, setSubmitting, isValid }) => {
    let body = JSON.stringify(values);
    fetch(registerUrl, {
      method: "post",
      body: body
    })
        .then(function(response) {
          return response.text();
        })
        .then(function(body) {
          let data = JSON.parse(body);
          if (data.result * 1 === 0 && data.message) {
            setErrorMessage(data.message);
            setSuccessMessage('');
          } else {
            setErrorMessage('');
            setSuccessMessage('Form successfully sent! Check your email and activate account.');
            resetForm({});
          }
        })
        .catch(function(error) {
          console.log("Send Request failed", error);
        });
  };

  const windowWidth = GetWindowWidth();

  const hideNotificationOnMobile = () => {
    if(windowWidth <= 600) {
      setErrorMessage('');
      setSuccessMessage('');
    }
  };

  return(
    <Wrapper>
      <MsgWrap>
        { errorMessage && <span className="errorMsg" onClick={ hideNotificationOnMobile }>{ errorMessage }</span> }
        { successMessage && <span className="successMsg" onClick={ hideNotificationOnMobile }>{ successMessage }</span> }
      </MsgWrap>
      <PopupWindow popupId="register-line-popup">
        <LinePopupContent/>
      </PopupWindow>

      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={values => {
          let errors = {};
          if(!(values.register_type.real_money || values.register_type.free_speen )){
            errors.register_type = 'ต้องการอย่างน้อยหนึ่งรายการ';
          }
          return errors;
        }}
        validationSchema={Yup.object().shape({
          username: Yup.string().required('จำเป็นต้องใช้'),
          email: Yup.string().email().required('จำเป็นต้องใช้'),
          password: Yup.string().required('จำเป็นต้องใช้'),
          phone: Yup.string().required('จำเป็นต้องใช้'),
          line: Yup.string().required('จำเป็นต้องใช้'),
        })}
        render={({ errors, status, touched, isSubmitting, isValid, values }) => (
          <Form id="regStaticForm">
            <h4>เลือกเกม</h4>
            <GamesWrap className="games-wrap">
              {gamesStatic.map((item) =>
                <GameNode key={item.label}>
                  {item.thumb &&
                    <img className="game-tile-img" width="42" src={item.thumb.source_url} alt={item.label}/>
                  }
                  <label className="checkbox-container" htmlFor={item.code}>
                    {item.label}
                    <Field type="radio" id={item.code} name={`games`} value={item.value}/>
                    <span className="checkmark">
                      <span className="mark"/>
                    </span>
                  </label>
                </GameNode>
              )}
            </GamesWrap>
            <div className="fieldWrap iconField">
              <IcomoonIcon icon="user" color={color.white} size={18} />
                <Field type="text" name="username" placeholder="ยูสเซอร์เนม" id="register-username-static"
                           value={values.username || ''}/>
                {errors.username && touched.username && <div className="error">! {errors.username}</div>}
              </div>
              <div className="fieldWrap iconField">
                <IcomoonIcon icon="mail" color={color.white} size={18} />
                <Field type="email" name="email" placeholder="อีเมล" value={values.email || ''}/>
                {errors.email && touched.email && <div className="error">! {errors.email}</div>}
              </div>
              <div className="fieldWrap iconField">
                <IcomoonIcon icon="pass" color={color.white} size={20} />
                <Field type="password" name="password" placeholder="รหัสผ่าน" id="register-password-static"
                  value={values.password || ''}/>
                  {errors.password && touched.password && <div className="error">! {errors.password}</div>}
              </div>
              <div className="two-fields">
                <div className="fieldWrap iconField">
                  <IcomoonIcon icon="mobile" color={color.white} size={18} />
                  <Field type="text" name="phone" placeholder="Phone" value={values.phone || ''}/>
                  {errors.phone && errors.phone &&
                      touched.phone && <div className="error">! {errors.phone}</div>}
                </div>
                <div className="fieldWrap iconField">
                  <IcomoonIcon icon="line" color={color.white} size={22} />
                  <Field type="text" name="line" placeholder="LINE ID" value={values.line || ''}/>
                  {errors.line && touched.line && <div className="error">! {errors.line}</div>}
                </div>
              </div>
              <div className="checkboxGroupWrap two-fields">
                <p>เกมที่คุณสนใจ</p>

                <div className="fieldWrap">
                  <Field
                    component={Checkbox}
                    name="register_type[free_speen]"
                    id="register-type-free-speen-static"
                    label="สมัครเล่น สล็อตฟรีสปิน"
                    value={values.register_type && values.register_type.free_speen ? values.register_type.free_speen : false}/>
                  </div>

                  <div className="fieldWrap">
                    <Field component={Checkbox} name="register_type[real_money]" id="register-type-real-money-static"
                      label="สมัครเล่นคาสิโน"
                      value={values.register_type && values.register_type.real_money ? values.register_type.real_money : false}/>
                  </div>

                  {Object.keys(errors).length === 1 && errors.register_type  && <div className="error">! {errors.register_type}</div>}
                </div>

                {status && status.msg && <div>{status.msg}</div>}
                <button aria-label="เข้าสู่ระบบ" className="button green-button" type="submit" disabled={(isSubmitting || !isValid)}>
                  <span>เข้าสู่ระบบ</span>
                  <IcomoonIcon icon="arrow-right" color={color.white} size={16}/>
                </button>

              </Form>
            )}
        />
      </Wrapper>
  )};


const RegistrationFormStatic = ({games}) =>{
  const value = useContext(StoreContext);
  const username = value.username;
  return(
      !username ? <React.Fragment>
        <FormBody games={games}/>
      </React.Fragment> : ''
  )};

export default RegistrationFormStatic;